import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import { scroller } from "react-scroll";
import { animated } from "react-spring";

export default function CrashReportComparison() {
    const handleButtonClick = () => {
        scroller.scrollTo("waitlist", {
          duration: 1000,
          delay: 0,
          smooth: true,
          offset: 100,
        });
      };
    return (
      <section className="relative bg-[#1a1a22] text-white py-28 px-32 md:px-12 lg:px-20">
        <div
        className="absolute inset-0 left-[25%] top-20 opacity-75"
        style={{
          backgroundImage:
            "url('/static/multy-round.svg')", // put your repeated icons image here
          backgroundRepeat: "no-repeat",
         
        }}
      ></div>
        {/* Title */}
        <div className="text-center max-w-5/6 mx-auto relative z-0">
          <h2 className="!text-3xl md:t!ext-[45px] !font-bold">
          Environmental Intelligence: The Future of QA
          </h2>
          <p className="mt-4 text-[#9d9dbb] md:!text-lg !text-base">
          Not only does this help QA but this helps developers help understand their gamers through bug fixes and a lifelong record of player history.
          </p>
         {/* Button */}
         <animated.div >
        <Button
            variant="contained"
            size="large"
            endIcon={
              <FontAwesomeIcon icon={faCaretRight} height={8} width={6} />
            }
            onClick={handleButtonClick}
            className="
              cursor-pointer rounded-lg border-none !bg-[#00DDDD] !mt-8
              px-6 py-3 text-white hover:!text-[#00DDDD] font-medium shadow-md hover:!bg-[#fff]
            "
          >
            Sign up
          </Button>
        </animated.div>
        </div>
  
        {/* Comparison Cards */}
        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-12 relative z-0">
      
          <img src="/static/crash-report/poger-left.svg" alt="" />
  
          {/* Arrow */}
          <div className="text-teal-400 text-5xl font-bold hidden md:block">
           <img src="/static/data-comparison/arrow-icon.svg" alt="" />
          </div>
  
          {/* With POGR */}
          <img src="/static/crash-report/poger-right.svg" alt="" />
        </div>
      </section>
    );
  }
  